import React, { Component } from "react";
import $ from "jquery"
import {
  Button,
  Pagination,
  message,
  Empty
} from "antd";
import MessagePushList from "../components/messagePush/MessagePushList";
import AddMessage from "../components/messagePush/AddMessage";
// import * as Actions from "../../actions/convergenceMedia";
import { connect } from "react-redux";
import {
  messagePush,
  getItemGroupList,
  getAddGroupList,
  getWithdrawGroupList,
  getGroupList,
} from "../../actions/convergenceMedia";
import * as utils from "../../utils/index";
import "antd/dist/antd.css";
import { HEADER_HEIGHT } from "../../constants";
import { Scrollbars } from "react-custom-scrollbars";

class MessagePush extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 1,
      limit: 10,
      dataList: [],
      listTotal: 0,
      currentMenuList: [],
      selectMenuList: [],
    };
  }
  componentDidMount() {
    this.pageChange();
    // this.getGroupLists();
  }
  // 新增消息
  addMessage() {
    window.layer.open({
      title: "发布消息",
      type: 2,
      content: "/cm-sites/pms/mediaFusion/addMessage.html", //"addMessage.html",
      area: ["620px", "460px"],
      btn: ["确定", "取消"],
      shadeClose: true,
      yes: function (index, layero) {
        var iframeWin = window[layero.find("iframe")[0]["name"]]; //得到iframe页的窗口对象，执行iframe页的方法：iframeWin.method();
        var groupId = iframeWin.currentSelect;
        var fansId = iframeWin.selectFansId;
        var content = iframeWin.getContent();
        if (!content) {
          window.layer.msg("没有输入消息");
          return;
        }

        var param = {};
        param.type = 1;
        param.content = content;
        param.groupId = groupId;
        param.fansId = fansId;
        param.senderName = "匿名";

        $.post("/cm-sites-pms/fansnotice/notice/add", param, function (data) {
          window.layer.close(index);
          window.location.reload();
        });
      },
      btn2: function (index, layero) {
        window.layer.close(index);
      },
    });
  }

  render() {
    let newSecondSelectColor =
      this.props.config && this.props.config.getValueByKey
        ? this.props.config.getValueByKey("newSecondSelectColor", "#0050B3")
        : "#0050B3";
    let height = window.innerHeight - HEADER_HEIGHT; //上部分70//
    return (
      <div>
        <div
          style={{
            backgroundColor: "#fff",
            marginTop: "15px",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "42px",
              lineHeight: "42px",
              padding: "0 15px",
              borderBottom: "1px solid #f6f6f6",
              color: "#333",
              borderRadius: "2px 2px 0 0",
              fontSize: "14px",
              margin: "15px 0px 0px 0px",
              backgroundColor: "#fff",
            }}
          >
            消息管理
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              marginTop: "15px",
              marginLeft: "15px",
              paddingBottom: "10px",
              borderBottom: "1px solid #f6f6f6",
            }}
          >
            <Button
              type="primary"
              style={{
                borderColor: newSecondSelectColor,
                backgroundColor: newSecondSelectColor,
              }}
              onClick={this.addIndexLink}
            >
              新增消息
            </Button>
          </div>
          {/* <AddMessage
            ref="addMessage"
            currentMenuList={this.state.currentMenuList}
            getItemGroupLists={(selectID) => this.getItemGroupLists(selectID)}
            // getAddGroupLists={(save) => this.getAddGroupLists(save)}
            selectMenuList={this.state.selectMenuList}
          /> */}
          {/* 新增消息 */}
          {/* <AddMessage ref="AddMessage" /> */}
          <div
            style={{
              width: "100%",
              margin: "0px 15px",
            }}
          >
            <table
              style={{
                border: "1px solid #666",
                marginTop: "10px",
                textAlign: "center",
              }}
            >
              <thead>
                <tr
                  style={{
                    border: "1px solid #e6e6e6",
                    backgroundColor: "#f6f6f6",
                    height: "35px",
                    lineHeight: "35px",
                  }}
                >
                  <th
                    style={{
                      width: "193px",
                      textAlign: "left",
                    }}
                  >
                    标题
                  </th>
                  <th
                    style={{
                      width: "520px",
                      textAlign: "left",
                    }}
                  >
                    消息
                  </th>
                  <th
                    style={{
                      width: "150px",
                    }}
                  >
                    发送对象
                  </th>
                  <th
                    style={{
                      width: "140px",
                    }}
                  >
                    图片
                  </th>
                  <th
                    style={{
                      width: "150px",
                    }}
                  >
                    发送人
                  </th>
                  <th
                    style={{
                      width: "141px",
                    }}
                  >
                    状态
                  </th>
                  <th
                    style={{
                      width: "212px",
                    }}
                  >
                    发送时间
                  </th>
                  <th
                    style={{
                      width: "180px",
                    }}
                  >
                    是否强制显示
                  </th>
                  <th style={{ width: "200px" }}>操作</th>
                </tr>
              </thead>
            </table>
            {/* 处理滚动条的方法以及自适应 */}
            <div style={{ height: height - 215, background: "white", width: "100%" }}>
              <Scrollbars ref={(Scrollbars) => (this.scrollRef = Scrollbars)}>
                {/* 循环组件 */}
                {
                  this.state.dataList.length === 0 ? <Empty style={{ position: "absolute", top: "45%", left: "45%" }} /> : null
                }
                {this.state.dataList &&
                  this.state.dataList.map((item, index) => {
                    return (
                      <MessagePushList
                        newSecondSelectColor={newSecondSelectColor}
                        key={index}
                        content={item.content}
                        groupName={item.groupName}
                        senderName={item.senderName}
                        status={item.status}
                        sendTime={item.sendTime}
                        force={item.force}
                        pictureUrl={item.pictureUrl}
                        title={item.title}
                        id={item._id}
                        createTime={
                          item.createTime && item.createTime
                            ? utils.formatDate(item.createTime) //转化时间
                            : ""
                        }
                        getWithdrawGroupList={() =>
                          this.getWithdrawGroupLists(item._id)
                        }
                      />
                    );
                  })}
              </Scrollbars>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
                marginBottom: "50px",
                marginRight: "30px"
              }}
            >
              <Pagination
                hideOnSinglePage={true}
                showQuickJumper
                current={this.state.pageNo}
                pageSize={this.state.limit}
                total={this.state.listTotal}
                showTotal={(total) => `共 ${total} 条`}
                showSizeChanger
                onChange={(page, pageSize) => this.onChange(page, pageSize)} //页码改变时回调
                onShowSizeChange={(page, pageSize) => {
                  this.onChange(page, pageSize); //每页条数改变回调
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
  addIndexLink = () => {
    // this.refs.addMessage.showModal();
    this.addMessage();
    // this.getGroupLists();
  };
  // // 删除
  // del = (item) => {
  //   this.delLists(item._id);
  //   this.pageChange();
  // };
  // delLists(delid) {
  //   let params = {
  //     id: delid,
  //   };
  //   delList(params, (res) => {
  //     let data = JSON.parse(res);
  //     if (data) {
  //       message.error("删除成功");
  //       // 直接更新
  //       // this.pageChange();
  //     } else {
  //       message.error("删除失败");
  //     }
  //   });
  // }

  // 页面改变时回调
  onChange(page, pageSize) {
    this.state.pageNo = page;
    this.state.limit = pageSize;
    // 每次改变页码时
    this.pageChange();
  }
  pageChange() {
    let params = {
      pageNo: this.state.pageNo,
      limit: this.state.limit,
    };
    messagePush(params, (res) => {
      let dataList = [];
      let listTotal = 0; //列表总数
      if (res && res.data) {
        dataList = res.data;
        listTotal = res.count;
      }
      this.setState({
        dataList: dataList,
        listTotal: listTotal,
      });
    });
  }
  // // 获取分组栏目数据
  // getGroupLists() {
  //   getGroupList((res) => {
  //     if (res) {
  //       this.setState({
  //         currentMenuList: res,
  //       });
  //     }
  //   });
  // }
  // // 选中分组时调用
  // getItemGroupLists(selectID) {
  //   getItemGroupList(selectID, (res) => {
  //     if (res) {
  //       this.setState({
  //         selectMenuList: res,
  //       });
  //     }
  //   });
  // }
  // // 添加至分组时调用
  // getAddGroupLists(save) {
  //   let params = {
  //     type: "1",
  //     content: save.content,
  //     groupId: save.typeKey1,
  //     fansId: save.typeKey2,
  //     senderName: "匿名",
  //   };
  //   getAddGroupList(params, (res) => {
  //     if (res === 0) {
  //       message.success("添加成功");
  //       this.pageChange();
  //     } else {
  //       message.success("添加失败");
  //     }
  //   });
  // }
  // 撤回时调用
  getWithdrawGroupLists(withDraw) {
    let params = {
      id: withDraw,
    };
    getWithdrawGroupList(params, (res) => {
      if (res) {
        message.success("撤回成功");
        this.pageChange();
      } else {
        message.error("撤回失败");
      }
    });
  }
}

function mapStateToProps(state) {
  return {
    config: state.systemReducer.config,
  }
}

export default connect(mapStateToProps)(MessagePush);
